import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import ScrollToTopOnReload from "./components/ScrollToTopOnReload";
import MainLayout from "./components/layouts/MainLayout";
import Home from "./homepage/Home";
import ClientsDashboard from "./pages/ClientsDashboard";
import Dashboard from "./pages/Dashboard";
import Funding from "./pages/Funding";
import HelpCenter from "./pages/HelpCenter";
import Invest from "./pages/Invest";
import InviteCode from "./pages/InviteCode";
import MyAccount from "./pages/MyAccount";
import Pricing from "./pages/Pricing";
import Profile from "./pages/Profile";
import RepairCredit from "./pages/RepairCredit";
import RepairTheirCredit from "./pages/RepairTheirCredit";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import Tutorials from "./pages/Tutorials";
import YourProgress from "./pages/YourProgress";

function App() {
  return (
    <>
      <Router>
        <ScrollToTopOnReload />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sign_in" element={<SignIn />} />
          <Route path="/sign_up" element={<SignUp />} />
          <Route path="/invite_code" element={<InviteCode />} />
          <Route path="" element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/your-progress" element={<YourProgress />} />
            <Route path="/repair-credit" element={<RepairCredit />} />
            <Route path="/tutorials" element={<Tutorials />} />
            <Route path="/my-account" element={<MyAccount />} />
            <Route path="/help-center" element={<HelpCenter />} />
            <Route
              path="/repair-their-credit"
              element={<RepairTheirCredit />}
            />
            <Route path="/clients-dashboard" element={<ClientsDashboard />} />
            <Route path="/invest" element={<Invest />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/funding" element={<Funding />} />
            <Route path="/pricing" element={<Pricing />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
